// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testInstanceId } from './TestInstance';
import { calibrationCurveId } from './CalibrationCurve';
import { calibrationCurveVersionId } from './CalibrationCurveVersion';
import { operatorId } from './Operator';
import { z } from 'zod';
export const testInstanceCurveVersion = z.object({
    test_instance_id: testInstanceId,
    calibration_curve_id: calibrationCurveId,
    calibration_curve_version_id: calibrationCurveVersionId,
    created_at: z.date(),
    created_by: operatorId.nullable(),
});
export const testInstanceCurveVersionInitializer = z.object({
    test_instance_id: testInstanceId,
    calibration_curve_id: calibrationCurveId,
    calibration_curve_version_id: calibrationCurveVersionId,
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
export const testInstanceCurveVersionMutator = z.object({
    test_instance_id: testInstanceId.optional(),
    calibration_curve_id: calibrationCurveId.optional(),
    calibration_curve_version_id: calibrationCurveVersionId.optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=TestInstanceCurveVersion.js.map